import faker from 'faker';
import { address } from './address.fixture';

const fakeDateOfBirth = (minAge = 18, maxAge = 80) => {
  const fromDate = new Date();
  fromDate.setFullYear(fromDate.getFullYear() - maxAge);

  const toDate = new Date();
  toDate.setFullYear(toDate.getFullYear() - minAge);

  return faker.date
    .between(fromDate, toDate)
    .toISOString()
    .split('T')[0];
};

function stakeholderWithRole(role = 'OWNER', country = 'DE') {
  const fakePersonalId = country =>
    ({
      DK: { personalId: '010192-1212', derivedDateOfBirth: '1992-01-01' },
      ES: { personalId: '12345678L', derivedDateOfBirth: null },
      FI: { personalId: '010192-123A', derivedDateOfBirth: '1992-01-01' },
      IT: { personalId: 'CLDNRG84L58H501R', derivedDateOfBirth: null },
      NO: { personalId: '01019212345', derivedDateOfBirth: '1992-01-01' },
      PL: { personalId: '92010163752', derivedDateOfBirth: '1992-01-01' },
      SE: { personalId: '19920101-1234', derivedDateOfBirth: '1992-01-01' },
      US: { personalId: '123-44-1234', derivedDateOfBirth: null },
    }[country] || { personalId: 'FK12344', derivedDateOfBirth: null });

  const { personalId, derivedDateOfBirth } = fakePersonalId(country);

  const fakeAddress = address(country);

  return {
    roles: [role],
    type: 'PERSON',
    data: {
      firstName: faker.name.firstName(),
      lastName: faker.name.lastName(),
      dateOfBirth: derivedDateOfBirth || fakeDateOfBirth(),
      address: fakeAddress,
      ssn: country === 'US' ? '123-44-1234' : null,
      personalId,
    },
  };
}

export function fakeStakeholders({ country }) {
  return [
    stakeholderWithRole('PARTNER', country),
    stakeholderWithRole('CONTROL_OVER_MANAGEMENT', country),
    stakeholderWithRole('ULTIMATE_BENEFICIAL_OWNER', country),
    stakeholderWithRole('APPLICANT', country),
    stakeholderWithRole('SOLE_TRADER', country),
    stakeholderWithRole('OWNER', country),
  ];
}
export function stakeholderStepConfig({ country }) {
  return {
    stakeholderUBO: {
      value: [stakeholderWithRole('ULTIMATE_BENEFICIAL_OWNER', country)],
      method: 'spreadArrayProperty',
      path: 'stakeholders',
    },
    stakeholderCOM: {
      value: [stakeholderWithRole('CONTROL_OVER_MANAGEMENT', country)],
      method: 'spreadArrayProperty',
      path: 'stakeholders',
    },
    stakeholderCEO: {
      value: [stakeholderWithRole('CONTROL_OVER_MANAGEMENT', country)],
      method: 'spreadArrayProperty',
      path: 'stakeholders',
    },
    stakeholderApplicant: {
      value: [stakeholderWithRole('APPLICANT', country)],
      method: 'spreadArrayProperty',
      path: 'stakeholders',
    },
    stakeholderPartner: {
      value: [stakeholderWithRole('PARTNER', country)],
      method: 'spreadArrayProperty',
      path: 'stakeholders',
    },
    stakeholderSoleTrader: {
      value: [stakeholderWithRole(country === 'US' ? 'OWNER' : 'SOLE_TRADER', country)],
      method: 'spreadArrayProperty',
      path: 'stakeholders',
    },
    ...partialStakeholderStepConfig(),
  };
}

function partialStakeholderStepConfig() {
  return {
    partialStakeholderApplicant: {
      value: [],
      method: 'spreadArrayProperty',
      path: 'stakeholders',
    },
    partialStakeholderCOM: {
      value: [],
      method: 'spreadArrayProperty',
      path: 'stakeholders',
    },
    partialStakeholderUBO: {
      value: [],
      method: 'spreadArrayProperty',
      path: 'stakeholders',
    },
    partialStakeholderSoleTrader: {
      value: [],
      method: 'spreadArrayProperty',
      path: 'stakeholders',
    },
    partialStakeholderPartner: {
      value: [],
      method: 'spreadArrayProperty',
      path: 'stakeholders',
    },
  };
}
